import React, { createContext, useContext } from 'react';

import { url as commonUrl } from '@finley-technologies/common';

import generatedIntrospection from 'types/dashboard-core-Introspection.generated.d';

import { ApolloClientProvider } from '~/contexts/ApolloClientProvider/ApolloClientProvider';

// Types
type ContextValue = { runInSandboxMode: boolean };

// Constants
const defaultValue: ContextValue = {
  // Disable sandbox execution mode by default
  runInSandboxMode: false,
};

// Exports
export const SandboxModeContext = createContext(defaultValue);
export const useSandboxMode = () => useContext(SandboxModeContext);

type SandboxModeProviderProps = { children: React.ReactNode };
/** Causes all children to use sandbox execution mode. */
export const SandboxModeProvider = ({ children }: SandboxModeProviderProps) => {
  return (
    <SandboxModeContext.Provider value={{ runInSandboxMode: true }}>
      <ApolloClientProvider
        headers={{ 'x-finley-execution-mode': 'sandbox' }}
        possibleTypes={generatedIntrospection.possibleTypes}
        uri={commonUrl.getGraphqlapiUrl()}
      >
        {children}
      </ApolloClientProvider>
    </SandboxModeContext.Provider>
  );
};
